import React from 'react';
import { Loader2 } from 'lucide-react';

const Spinner = ({ size = 40, className = '' }) => (
    <div className={`flex justify-center py-12 ${className}`}>
        <Loader2 className="animate-spin text-pink-500" size={size} />
    </div>
);

export default Spinner;
